import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./hooks/use-auth";
import { HomePage } from "./pages/home-page";
import { AuthPage } from "./pages/auth-page";
import { ChatPage } from "./pages/chat-page";
import { PersonaPage } from "./pages/persona-page";
import { SettingsPage } from "./pages/settings-page";
import { MembershipPage } from "./pages/membership-page";

// 受保护的路由组件
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isSignedIn, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  
  if (!isSignedIn) {
    return <Navigate to="/auth" replace />;
  }
  
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/chat" element={<ChatPage />} />
      <Route path="/membership" element={<MembershipPage />} />
      <Route 
        path="/personas" 
        element={
          <ProtectedRoute>
            <PersonaPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/settings" 
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        } 
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
